import { connect } from 'react-redux'
import completedSelector from './completedSelector'
import Completed from './Completed'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  completedSelector,
  {}
)(Completed))
